import { PasswordErrorOption } from '../types';
export class PasswordBreachedError extends Error {
  constructor() {
    super('PasswordBreachedError');
  }

  getMessage() {
    return PasswordErrorOption.Breached;
  }

}